import React, { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileEdit, Check, X, Download } from "lucide-react";
import { ChannelBadge } from "@/components/ChannelBadge";

export default function CompanyProposals() {
  const [items, setItems] = useState([]);
  const refresh = () => api.get("/payments/proposals").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); }, []);

  const respond = async (id, accepted) => {
    try {
      await api.post(`/payments/proposals/${id}/respond`, { accepted });
      toast.success(accepted ? "Proposta accettata" : "Proposta rifiutata");
      refresh();
    } catch (e) { toast.error("Errore"); }
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Proposte commerciali</h1>
      <p className="text-sm text-slate-600 mb-6">Visualizza, accetta o rifiuta le proposte ricevute dal team CXOORA.</p>
      <div className="space-y-3">
        {items.map(p => (
          <div key={p.id} className="cxo-card p-6">
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <FileEdit className="text-[#2D6BFF]" size={18} />
                  <h3 className="font-semibold text-slate-900">{p.title}</h3>
                  <ChannelBadge channel={p.proposal_type === "marketplace" ? "marketplace" : "agency"} size="xs" />
                  <Badge className={`border-0 ${p.status === "accepted" ? "bg-[#E9F8F1] text-[#1F9D6A]" : p.status === "sent" ? "bg-[#EAF0FF] text-[#2D6BFF]" : p.status === "rejected" ? "bg-red-100 text-red-700" : "bg-slate-100 text-slate-700"}`}>{p.status}</Badge>
                </div>
                <p className="mt-2 text-sm text-slate-600">{p.description}</p>
                <div className="mt-3 flex flex-wrap gap-x-6 gap-y-1 text-sm cxo-tabular">
                  {p.activation_fee && <span><strong>Attivazione:</strong> €{p.activation_fee.toLocaleString('it-IT')}</span>}
                  {p.monthly_fee && <span><strong>Mensile:</strong> €{p.monthly_fee.toLocaleString('it-IT')}</span>}
                  {p.total && <span><strong>Totale:</strong> €{p.total.toLocaleString('it-IT')}</span>}
                </div>
              </div>
              <div className="flex flex-col gap-2 items-stretch">
                <a
                  href={`${API_BASE}/pdf/proposal/${p.id}?auth=${encodeURIComponent(localStorage.getItem("cxoora_token") || "")}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`download-proposal-pdf-${p.id}`}
                >
                  <Button size="sm" variant="outline" className="w-full gap-1.5"><Download size={14} /> PDF</Button>
                </a>
                {p.status === "sent" && (
                  <>
                    <Button size="sm" onClick={() => respond(p.id, true)} className="bg-[#1F9D6A] text-white" data-testid={`accept-proposal-${p.id}`}><Check size={14} className="mr-1" /> Accetta</Button>
                    <Button size="sm" variant="outline" onClick={() => respond(p.id, false)}><X size={14} className="mr-1" /> Rifiuta</Button>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
        {!items.length && <div className="cxo-card p-10 text-center text-slate-500">Nessuna proposta al momento.</div>}
      </div>
    </div>
  );
}
